import moment from 'moment';
import {
  getLabelWithDefaultStr,
} from '../../utils/i18n';

// eslint-disable-next-line import/prefer-default-export
export function getRemainDayStr(time, i18n) {
  const remainDays = moment(time).diff(moment(), 'days');
  const atLeastOneDay = getLabelWithDefaultStr(
    'exchange-staking-remaining-days',
    i18n,
    '天后开始');
  if (remainDays > 0) {
    return `${remainDays} ${atLeastOneDay}`;
  }

  return getLabelWithDefaultStr(
    'exchange-staking-coming-today',
    i18n,
    '即将开始');
}
